import React, { useState, useEffect, useRef } from "react";
import "./LogDebug.css"; // Import des styles

// Singleton pour accéder au logger
let logInstance = null;

const LogDebug = ({ isActive }) => {
  const [logs, setLogs] = useState([]);
  const [isVisible, setIsVisible] = useState(true); // Gérer l'état visible/invisible
  const [position, setPosition] = useState({ x: window.innerWidth - 520, y: window.innerHeight - 320 }); // Position initiale
  const [size, setSize] = useState({ width: 500, height: 300 }); // Taille initiale
  const dragStartPosition = useRef({ x: 0, y: 0 });

  // Append un log simple
  const addLog = (message) => {
    setLogs((prevLogs) => [...prevLogs, typeof message === "object" ? JSON.stringify(message) : message]);
    setIsVisible(true);
  };

  // Append un log avec détails
  const addLogDetail = (message) => {
    setLogs((prevLogs) => [...prevLogs, `[DETAIL] ${typeof message === "object" ? JSON.stringify(message) : message}`]);
    setIsVisible(true);
  };

  // Vide tous les logs
  const clearLogs = () => {
    setLogs([]);
  };

  // Définit les méthodes accessibles globalement
  useEffect(() => {
    logInstance = {
      log: addLog,
      logDetail: addLogDetail,
      clear: clearLogs,
    };

    // Fonction de nettoyage
    return () => {
      logInstance = null;
    };
     // le return dans le useEffect est utilisé pour définir une fonction de nettoyage qui est exécutée lorsque le composant est démonté ou avant que le useEffect ne soit réexécuté. Dans ce cas, la fonction de nettoyage réinitialise logInstance à null, ce qui aide à prévenir les fuites de mémoire et à gérer correctement les effets secondaires.
  }, []);

  // Méthodes pour le redimensionnement
  const startResizing = (e) => {
    dragStartPosition.current = {
      x: e.clientX,
      y: e.clientY,
      width: size.width,
      height: size.height,
    };
    document.addEventListener("mousemove", onResize);
    document.addEventListener("mouseup", stopResizing);
  };

  const onResize = (e) => {
    const newWidth = Math.max(300, dragStartPosition.current.width + (e.clientX - dragStartPosition.current.x));
    const newHeight = Math.max(200, dragStartPosition.current.height + (e.clientY - dragStartPosition.current.y));
    setSize({ width: newWidth, height: newHeight });
  };

  const stopResizing = () => {
    document.removeEventListener("mousemove", onResize);
    document.removeEventListener("mouseup", stopResizing);
  };

  const maxSize = () => {
    setSize({ width: window.innerWidth - 20, height: size.height });
    setPosition({
        x: 0,
        y: 0, //window.innerHeight - dragStartPosition.current.y,
      });
  }
  
    // Méthodes pour le déplacement
    const startDragging = (e) => {
        dragStartPosition.current = {
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        };
        document.addEventListener("mousemove", onDrag);
        document.addEventListener("mouseup", stopDragging);
    };
    const onDrag = (e) => {
        setPosition({
          x: e.clientX - dragStartPosition.current.x,
          y: e.clientY - dragStartPosition.current.y,
        });
      };
      const stopDragging = () => {
        document.removeEventListener("mousemove", onDrag);
        document.removeEventListener("mouseup", stopDragging);
      };

  // Si `isActive` est false, ne rien afficher
  if (!isActive || !isVisible) return null;

  return (
    <div
      className="log-debug-container"
      style={{
        transform: `translate(${position.x}px, ${position.y}px)`,
        width: `${size.width}px`,
        height: `${size.height}px`,
      }}
    >
      {/* Zone de logs */}
      <div className="log-debug-content">
        {logs.map((log, index) => (
          <div key={index} className="log-debug-message">
            {index} : {log}
          </div>
        ))}
      </div>
      {/* Footer avec les actions */}
      <div className="log-debug-footer">
        <button onMouseDown={startResizing} onDoubleClick={maxSize}>SIZE</button>
        <button className="log-debug-move-btn" onMouseDown={startDragging}>MOVE</button>
        <button onClick={clearLogs}>Clear Logs</button>
        <button onClick={() => setIsVisible(false)}>FERMER X</button>
      </div>
      {/* Poignée pour redimensionner */}
    </div>
  );
};

// Singleton pour le debugLogger
export const debugLogger = {
  /**
   * Log a message with optional stack trace for debugging.
   * @param {string} message - The message to log.
   */


  /**
   * Log a simple message.
   */
  log: (message) => {
    if (logInstance && logInstance.log) {
        // Log normal sans détail
        logInstance.log(message);
    } else {
      console.warn("LogDebug component is not active or loaded.");
    }
  },

  /**
   * Log a detailed message with stack trace.
   */
  logDetail: (message) => {
    if (logInstance && logInstance.logDetail) { // Correction ici
      const error = new Error();
      let callerInfo = "";

      if (error.stack) {
        const stackLines = error.stack.split("\n");

        if (stackLines.length >= 3) {
          const callerLine = stackLines[2].trim();
          const atTab = callerLine.split(" ");

          const fileMatch = callerLine.match(/(https?:\/\/[^\s)]+:\d+:\d+|\b\/[^:]+:\d+:\d+)/);
          const fileInfo = fileMatch ? fileMatch[0] : "Unknown Location";

          callerInfo = `${atTab[0] || ''} | ${atTab[1] || ''} | ${atTab[2] || ''} | ${atTab[3] || ''} | ${fileInfo}`;

        }
      }

      logInstance.logDetail({ message, caller: callerInfo }); // Correction ici

    } else {
      console.warn("LogDebug component is not active or loaded.");
    }
  },

  /**
   * Clears the log if the logInstance is active.
   */
  clear: () => {
    if (logInstance && logInstance.clear) {
      logInstance.clear();
    } else {
      console.warn("LogDebug component is not active or loaded.");
    }
  }
};



export default LogDebug;
